import type { Course } from "@/core/types";
import { modulAbsaetze } from "./absaetze";
import { modulAnsicht } from "./ansicht";
import { modulBarrierefreiheit } from "./barrierefreiheit";
import { modulBilder } from "./bilder";
import { modulEinfuegen } from "./einfuegen";
import { modulFeinschliff } from "./feinschliff";
import { modulFormatvorlagen } from "./formatvorlagen";
import { modulFormulare } from "./formulare";
import { modulKapitelnummerierung } from "./kapitelnummerierung";
import { modulSeitengestaltung } from "./seitengestaltung";
import { modulSeitenlayout } from "./seitenlayout";
import { modulSeriendruck } from "./seriendruck";
import { modulSuchen } from "./suchen";
import { modulTabellen } from "./tabellen";
import { modulVerweise } from "./verweise";
import { modulVorlagen } from "./vorlagen";
import { modulZusammenarbeit } from "./zusammenarbeit";
import { modulSchriftarten } from "./schriftarten";

/**
 * Word-Komplettkurs.
 *
 * Bewusst ein einziger Kurs statt getrennter Einsteiger- und Aufbaukurse. Die
 * Module sind über `level` in "Grundlagen" und "Aufbau" eingeordnet, damit
 * erkennbar bleibt, ab wo es über den Arbeitsalltag hinausgeht.
 *
 * Die Grundlagen folgen den drei Formatierungsebenen von Word – Zeichen, Absatz,
 * Seite – und enden bei der Zusammenarbeit im Team.
 */
export const wordGrundlagenkurs: Course = {
  id: "word-grundlagen",
  host: "Word",
  title: "Word Komplettkurs",
  summary:
    "Microsoft Word von Grund auf: vom ersten formatierten Text bis zu Verzeichnissen, " +
    "Seriendruck, Formularen, Dokumentvorlagen und Makros.",
  level: "Komplettkurs",
  modules: [
    modulSchriftarten,
    modulFormatvorlagen,
    modulAbsaetze,
    modulFeinschliff,
    modulSeitenlayout,
    modulSeitengestaltung,
    modulTabellen,
    modulBilder,
    modulEinfuegen,
    modulSuchen,
    modulZusammenarbeit,
    modulKapitelnummerierung,
    modulVerweise,
    modulSeriendruck,
    modulFormulare,
    modulVorlagen,
    modulAnsicht,
    modulBarrierefreiheit,
  ],
};
